/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useMemo } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Material Dashboard 2 PRO React components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import Box from '@mui/material/Box';

// Material Dashboard 2 PRO React examples
import SalesTableCell from "./SalesTableCell";
import TableCell from "@mui/material/TableCell";

// const getColorByProductivity = (value) => {
//   if (value === "<10" || value === "< 19") return "#e74c3c"; // Red
//   if (value === "11~30" || value === "20~39") return "#f39c12"; // Orange
//   if (value === "31~50" || value === "40~59") return "#f1c40f"; // Yellow
//   if (value === "51~70" || value === "60~79") return "#00bcd4"; // Cyan
//   if (value === ">70" || value === "> 80") return "#2ecc71"; // Green
//   return "#bdc3c7"; // Default gray
// };

function SalesTable({ title, rows, shadow }) {
  const renderTableCells = rows.map((row, key) => {
    const tableRows = [];
    const rowKey = `row-${key}`;


    Object.entries(row).map(([key, value]) => {
      if (key === "color") return null;
    
      const colorBox = row.color;
    
      tableRows.push(
        <SalesTableCell
          key={value}
          title={key}
          content={value}
          colorBox={colorBox}
          noBorder={key === rows.length - 1}
        />
      );
    });
    
    // Object.entries(row).map(([cellTitle, cellContent]) => {
    //   if (cellTitle === "color") return null; // ✅ Skip 'color' key

    //   if (Array.isArray(cellContent)) {
    //     tableRows.push(
    //       <SalesTableCell
    //         key={cellContent[1]}
    //         title={cellTitle}
    //         content={cellContent[1]}
    //         image={cellContent[0]}
    //         noBorder={key === rows.length - 1}
    //       />
    //     );
    //   } else {
    //     const colorBox = row.color && cellTitle === "productivityhr" ? row.color : undefined;
    
    //     tableRows.push(
    //       <SalesTableCell
    //         key={cellContent}
    //         title={cellTitle}
    //         content={cellContent}
    //         colorBox={colorBox}
    //         noBorder={key === rows.length - 1}
    //       />
    //     );
    //   }
    // });

    
    // Object.entries(row).map(([cellTitle, cellContent]) => {
    //   if (Array.isArray(cellContent)) {
    //     tableRows.push(
    //       <SalesTableCell
    //         key={cellContent[1]}
    //         title={cellTitle}
    //         content={cellContent[1]}
    //         image={cellContent[0]}
    //         noBorder={key === rows.length - 1}
    //       />
    //     );
    //   } else {
    //     const colorBox =
    //       cellTitle === "productivityhr" ? getColorByProductivity(cellContent) : undefined;
    
    //     tableRows.push(
    //       <SalesTableCell
    //         key={cellContent}
    //         title={cellTitle}
    //         content={cellContent}
    //         colorBox={colorBox}
    //         noBorder={key === rows.length - 1}
    //       />
    //     );
    //   }
    // });

    // Object.entries(row).map(([cellTitle, cellContent]) =>
    //   Array.isArray(cellContent)
    //     ? tableRows.push(
    //         <SalesTableCell
    //           key={cellContent[1]}
    //           title={cellTitle}
    //           content={cellContent[1]}
    //           image={cellContent[0]}
    //           noBorder={key === rows.length - 1}
    //         />
    //       )
    //     : tableRows.push(
    //         <SalesTableCell
    //           key={cellContent}
    //           title={cellTitle}
    //           content={cellContent}
    //           noBorder={key === rows.length - 1}
    //         />
    //       )
    // );

    return <TableRow key={rowKey}>{tableRows}</TableRow>;
  });

  return (
    <TableContainer sx={{ height: "100%", boxShadow: !shadow && "none" }}>
      <Table>
        {title ? (
          <TableHead>
            <MDBox component="tr" width="100%" mb={1.5}    display="flex"
    justifyContent="center">
              <MDTypography variant="h6" component="td">
                {title}
              </MDTypography>
            </MDBox>
              {/* <TableRow sx={{ backgroundColor: "#ffe0b2" }}>
    <TableCell colSpan={1000} sx={{ borderBottom: 'none', p: 0 }}>
      <Box display="flex" justifyContent="center" alignItems="center" width="100%">
        <MDTypography variant="h6">{title}</MDTypography>
      </Box>
    </TableCell>
  </TableRow>
  <TableRow>
    <TableCell colSpan={1000} align="center" sx={{ borderBottom: 'none' }} sx={{ backgroundColor: "#ffe0b2" }}>
      <MDTypography variant="h6">
        {title}
      </MDTypography>
    </TableCell>
  </TableRow> */}
          </TableHead>
        ) : null}
        <TableBody>{useMemo(() => renderTableCells, [rows])}</TableBody>
      </Table>
    </TableContainer>
  );
}

// Setting default values for the props of SalesTable
SalesTable.defaultProps = {
  title: "",
  rows: [{}],
  shadow: true,
};

// Typechecking props for the SalesTable
SalesTable.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.object),
  shadow: PropTypes.bool,
};

export default SalesTable;
